import React, { PropsWithChildren, useMemo } from 'react';
import { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import { Errors } from '../Errors';
import { Description } from '../Description';
import classNames from 'classnames';

export type FieldContainerProps = PropsWithChildren<{
    errorId?: string;
    descriptionId?: string;
    errors?: string[];
    description?: string;
    className?: string;
}>;

export const FieldContainer: FunctionComponent<FieldContainerProps> = ({
    errorId,
    descriptionId,
    description,
    errors = [],
    className,
    children,
}) => {
    const errorOrDescription = useMemo(() => {
        if (errors && errors.length > 0) {
            return <Errors id={errorId} errors={errors} />;
        }

        return <Description id={descriptionId} description={description} />;
    }, [errors, description]);

    return (
        <div className={classNames(styles.fieldContainer, className)}>
            {children}
            {errorOrDescription}
        </div>
    );
};
